<template>
    <section class="my-4 mx-4 px-4">
        <div class="mx-auto my-2 text-sm  p-3 flex items-center space-x-4 border-b border-gray-dark">
            <div class="text-4xl font-bold bg-primary text-white p-4 rounded-md">
                <span>30</span><span>%</span>
            </div>
            <div class="text-xl">
                <p>For every paying customer you refer, we pay 30% of our revenue to you.</p>
                <p>Every single month, as long as they remain our customers.</p>
            </div>
        </div>

        <p class="my-6">
            Inbox is an addiction.
        </p>

        <p class="my-6">
            We are committed to free brilliant minds from their inboxes.
        </p>

        <p class="my-6">
            To give them their time back.
        </p>

        <p class="my-6">
            To make their mindspace available to tackle with bigger problems in the world.
        </p>

        <p class="my-6">
            And to help them make the world a better place for everybody!
        </p>

        <p class="my-6">
            That's our mission!
        </p>

        <p class="my-6">
            Your help counts.
        </p>

        <p class="my-6 text-xl">
            Welcome to our <strong><font-awesome-icon :icon="['fas', 'user-astronaut']"></font-awesome-icon> Ambassador Program</strong>.
        </p>

        <button
            class="my-4 py-2 px-4 rounded-md bg-primary-lighter text-primary font-bold"
            :loading="false"
            :state="'...'"
            @click="become"
        >
            <strong>Become an ambassador</strong>
        </button>
    </section>
</template>

<script>
import BecomeAmbassadorModal from './BecomeAmbassadorModal.vue'

export default {
    data() {
        return {}
    },
    methods: {
        become() {
            Modal.show(BecomeAmbassadorModal)
                .then(() => {
                    window.location.reload();
                })
                .catch(err => console.error);
        }
    }
}
</script>

<style>

</style>